import type React from "react"
import { Text } from "@mantine/core"

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  return "An unexpected error occurred"
}

export function EmptyValue(): React.ReactElement {
  return (
    <Text component="span" size="sm" fs="italic" c="gray.5">
      —
    </Text>
  )
}
